// unDraw images
// https://undraw.co/illustrations
import img_1 from '../../../assets/images/toiawase.png'
import img_2 from '../../../assets/images/soudan.png'
import img_3 from '../../../assets/images/taiken.png'
import img_4 from '../../../assets/images/shinsei.png'
import img_5 from '../../../assets/images/kaishi.png'

export const processObjOne = {
    lightBg: false,
    lightText: false,
    lightTextDesc: false,
    topLine: "",
    headline: "１．お問い合わせ",
    description: "まずは電話やメールでお問い合わせください。\n質問や見学、ご相談日をご案内いたします。",
    buttonLabel: "",
    imgStart: true,
    img: img_1,
    alt: "inqury",
    darkText: true
}

export const processObjTwo = {
    lightBg: false,
    lightText: false,
    lightTextDesc: false,
    topLine: "",
    headline: "２．ご相談",
    description: "施設や雰囲気、スタッフや利用している子ども達の\n様子を見に、ぜひ一度「ことり」にお越しください。",
    buttonLabel: "",
    imgStart: false,
    img: img_2,
    alt: "discuss",
    darkText: true
}

export const processObjThree = {
    lightBg: false,
    lightText: false,
    lightTextDesc: false,
    topLine: "",
    headline: "3．体験",
    description: "お子様にとって「ことり」が良いところかどうか\n保護者様の付き添いがなくてもご利用が可能か\n「ことり」でどのような支援をさせていただけるかなど\n詳しくお話しいたします。",
    buttonLabel: "",
    imgStart: true,
    img: img_3,
    alt: "trial",
    darkText: true
}

export const processObjFour = {
    lightBg: false,
    lightText: false,
    lightTextDesc: false,
    topLine: "",
    headline: "４．申請",
    description: "ご利用をお考えの場合はお子様の特性や保護者様のご要望、日時、送迎の有無などをお教えいただき「ことり」での利用プランを作成しご提案いたします。\n区役所への通所受給者申請がまだお済でない方は、お手続きの段取りをお伝えいたします。",
    buttonLabel: "",
    imgStart: false,
    img: img_4,
    alt: "apply",
    darkText: true
}

export const processObjFive = {
    lightBg: false,
    lightText: false,
    lightTextDesc: false,
    topLine: "",
    headline: "５．ご利用開始",
    description: "最初は不安を感じられるかも知れませんが\nすぐに打ち解けられるように支援しますので\nご安心ください。",
    buttonLabel: "",
    imgStart: true,
    img: img_5,
    alt: "start",
    darkText: true
}